<div class="flex flex-col gap-2">
  <ng-container *ngIf="isSummary">
    <h1 class="text-5xl" [class.isSummary]="isSummary">
      {{ product.title }}
    </h1>
    <app-product-label
      [product]="product"
      [relativePosition]="true"
      [highestDiscount]="highestDiscount"
    ></app-product-label>
  </ng-container>
</div>
<div class="flex h-full flex-row justify-end">
  <div class="flex w-full flex-col justify-start lg:justify-end">
    <div class="configuration-options-container h-full w-full" (scroll)="appS.closeAllTooltips()">
      <app-product-custom-elements
        *ngIf="product.subType === ProductSubType.CUSTOM"
        [product]="product"
        (changes)="emitAction('onUpdateOptionsSelected', $event)"
      >
      </app-product-custom-elements>

      <app-products-in-pack
        *ngIf="product.packProducts?.length"
        [packProducts]="product.packProducts"
      ></app-products-in-pack>

      <div
        *ngIf="!product.hasVariant && !product.packProducts?.length && product.subType !== ProductSubType.CUSTOM"
        class="no-variation-message mb-6"
      >
        Este producto no dispone de variaciones
      </div>
      <app-product-variants
        *ngIf="product.hasVariant"
        [options]="product.options"
        [variants]="product.variants"
        [selected]="variantSelected$ | async"
        [galleries]="galleries"
        [product]="product"
        (changes)="emitAction('onVariantChange', $event)"
      >
      </app-product-variants>
    </div>

    <div class="flex w-full flex-col items-center">
      <div class="cantidad-precio-container flex w-full flex-col items-center gap-3.5 xl:flex-row xl:justify-between">
        <div class="qty-stepper-container flex h-full w-full flex-initial flex-row items-center justify-center">
          <app-qty-stepper
            size="large"
            [qty]="product.qty"
            [min]="1"
            [isProduct]="true"
            [max]="product.allowSaleNoStock ? 100 : product.stock > 0 ? maxQtyToAdd(product) : 0"
            (changes)="
              product.subType === ProductSubType.CUSTOM
                ? addQtyCustomProduct($event)
                : emitAction('onQtyChange', $event)
            "
            [showQty]="true"
            class="w-full"
          >
          </app-qty-stepper>
        </div>

        <div [ngClass]="{ addToCartFromPopup: measurement }" class="flex w-full flex-1 flex-row justify-center">
          <ion-button
            class="custom-button"
            [ngClass]="{ addToCartFromPopup: measurement }"
            expand="block"
            (click)="emitAction('onAdd', product)"
            [disabled]="
              !product.canAdd ||
              product.status != 'active' ||
              (product.subType === ProductSubType.CUSTOM && !product.customElementsSelected)
            "
          >
            <div class="inner-button ion-text-nowrap flex h-full w-full flex-row items-center justify-between">
              <div [ngClass]="{ addToCartFromPopup: measurement }" class="flex flex-row items-center gap-2.5">
                <ion-icon [ngClass]="{ addToCartFromPopup: measurement }" src="assets/icon/cart-add.svg"></ion-icon>
                <div [ngClass]="{ addToCartFromPopup: measurement }" class="text-lg">Agregar al carrito</div>
                &nbsp;
              </div>

              <div
                *ngIf="product.subType !== ProductSubType.CUSTOM || product.customElementsSelected"
                class="flex flex-col items-end justify-end gap-2"
              >
                <div *ngIf="product.discount">
                  <span class="oldPrice">
                    {{ product.unitPrice.amt * product.qty | currency }}
                  </span>
                </div>
                <span class="price-custom"> {{ product.price.amt * product.qty | currency }}</span>
              </div>
            </div>
          </ion-button>
        </div>
      </div>
    </div>

    <ion-text *ngIf="!product.canAdd && product.status == 'active'" color="danger">
      <p class="text text-center">¡Producto no disponible!</p>
    </ion-text>

    <ion-text *ngIf="product.status != 'active'" color="danger">
      <p class="text text-center">¡Este producto ya no está en venta!</p>
    </ion-text>
  </div>
</div>
